module.exports = __webpack_public_path__ + "img/gallery-img-3.700a1304.jpg";